"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../webview/types");
const dom_1 = require("../utils/dom");
const store_locale_1 = require("../utils/store-locale");
const flagr_1 = require("../flagr");
const webview_1 = require("../webview");
const zendesk_1 = require("../zendesk");
const tokens_1 = require("./tokens");
const DIXA_URL = 'https://messenger.dixa.io/bootstrap.js';
const DIXA_SCRIPT_ID = 'external-dixa-sdk';
function load() {
    // skip loading scripts for WebView, because a native SDK will be used instead
    if (!(0, webview_1.isInWebView)()) {
        (0, dom_1.injectScript)(DIXA_URL, DIXA_SCRIPT_ID);
    }
}
function init(data) {
    var _a;
    const { storeCode, locale } = (0, store_locale_1.getStoreLocale)();
    (0, flagr_1.fetchFeatureFlags)(storeCode);
    const messengerToken = (_a = data.messengerToken) !== null && _a !== void 0 ? _a : (0, tokens_1.getMessengerToken)(locale, storeCode);
    window._dixa_.invoke('init', Object.assign(Object.assign({}, data), { messengerToken }));
}
function toggle(visible) {
    if ((0, webview_1.isInWebView)()) {
        (0, webview_1.fireEvent)(types_1.WebViewEventName.TOGGLE_INTERCOM, { visible });
    }
    else {
        // on show
        if (visible) {
            const zendeskFlag = (0, flagr_1.getZendeskFlag)();
            if ((zendeskFlag === null || zendeskFlag === void 0 ? void 0 : zendeskFlag.variantKey) === 'enabled') {
                (0, zendesk_1.redirectToZendesk)(zendeskFlag.variantAttachment);
            }
            else {
                window._dixa_.invoke('setWidgetOpen', visible);
            }
        }
        // on hide
        else {
            window._dixa_.invoke('setWidgetOpen', visible);
        }
    }
}
const SDK = {
    load,
    init,
    shutdown: () => window._dixa_.invoke('shutdown'),
    setUser: (data) => window._dixa_.invoke('setUserIdentity', data),
    purgeUser: () => window._dixa_.invoke('purgeUserIdentity'),
    show: () => toggle(true),
    hide: () => toggle(false),
    startConversation: () => window._dixa_.invoke('startConversation'),
    endConversation: () => window._dixa_.invoke('endConversation'),
    addListener: (event, listener) => window._dixa_.addListener(event, listener),
    removeListener: (event, listener) => { var _a, _b; return (_b = (_a = window._dixa_).removeListener) === null || _b === void 0 ? void 0 : _b.call(_a, event, listener); },
};
exports.default = SDK;
//# sourceMappingURL=sdk.js.map